import { CombinedRow } from "@/types/itemsheet";
import { create } from "zustand";

interface EstimateHistoryState {
  history: CombinedRow[][];
  pointer: number;
  push: (snapshot: CombinedRow[]) => void;
  undo: () => CombinedRow[] | null;
  redo: () => CombinedRow[] | null;
  reset: () => void;
}

export const useEstimateHistoryStore = create<EstimateHistoryState>(
  (set, get) => ({
    history: [],
    pointer: -1,

    push: (snapshot) => {
      const { history, pointer } = get();
      const newHistory = [...history.slice(0, pointer + 1), snapshot];
      set({ history: newHistory, pointer: newHistory.length - 1 });
    },

    undo: () => {
      const { pointer, history } = get();
      if (pointer > 0) {
        set({ pointer: pointer - 1 });
        return history[pointer - 1];
      }
      return null;
    },

    redo: () => {
      const { pointer, history } = get();
      if (pointer < history.length - 1) {
        set({ pointer: pointer + 1 });
        return history[pointer + 1];
      }
      return null;
    },

    reset: () => set({ history: [], pointer: -1 }),
  })
);
